/* This example requires Tailwind CSS v2.0+ */
import classNames from "classnames";
import { ReactNode } from "react";

export interface ListProps<T extends { id: string | number }> {
  items: T[] | undefined;
  render: (item: T, i: number, items: T[]) => ReactNode;
  className?: string;
  actions: (item: T, i: number, items: T[]) => ReactNode;
}

export function List<T extends { id: string | number }>({
  items = [],
  render,
  className,
  actions,
}: ListProps<T>) {
  return (
    <ul className={classNames("divide-y divide-border", className)}>
      {items.map((item, i) => (
        <ListItem key={item.id}>
          <ListItemContent>{render(item, i, items)}</ListItemContent>
          {typeof actions === "function" && (
            <div className="flex items-end justify-end ml-8 shrink-0">
              {actions(item, i, items)}
            </div>
          )}
        </ListItem>
      ))}
    </ul>
  );
}

function ListItem({ children }: { children: ReactNode }) {
  return (
    <li>
      <div className="block">
        <div className="flex items-start px-2 py-4 sm:items-center ">{children}</div>
      </div>
    </li>
  );
}

function ListItemContent({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={classNames("flex-1 min-w-0 sm:flex sm:items-center sm:justify-between", className)}
    >
      {children}
    </div>
  );
}

function ListItemGroup({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={classNames("flex justify-between sm:contents", className)}>{children}</div>
  );
}

List.Item = ListItem;
List.ItemGroup = ListItemGroup;
